import { render, staticRenderFns } from "./yuyueDo.vue?vue&type=template&id=4a453f6a"
import script from "./yuyueDo.vue?vue&type=script&lang=js"
export * from "./yuyueDo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports